/**
 * @file  audit/content.ts
 * @description  handles the json content for the audit component
 *
 * @author ogarcia (ozkary)
 *
 */

import { ModalMessages } from '../../components/ModalManager/styles';

// load the audit information per brand and edition comobination
// e.i  meineke: ppm, vsc
const resources = (async (): Promise<ModalMessages> => (await import('../../content/audit.json')).default)();

// export the promise. The component must await the resuults
export const ContentLoader = resources;
